import React, { useEffect, useState } from 'react';
import { BsBarChartFill } from "react-icons/bs";
import { PiScalesFill } from "react-icons/pi";
import * as THREE from '../../../../dist/three.module.js';

import {
    fmesh,
    fullmesh,
    fmeshPoints
} from '../../../core/globalVariables';

export const getMapScaleKm = (map) => {
    if (!map) return '';
    const scaleKm = (591657550.5 / Math.pow(2, map.getZoom() - 1)) / 1000;
    const precision = scaleKm < 10 ? 2 : scaleKm < 1000 ? 1 : 0;
    return `${scaleKm.toFixed(precision)} km`;
};

const ScaleIndicator = ({
    isComparing,
    handleCompareClick,
    mapRef,
    globalState,
    globalRefs,
}) => {
    const [scale, setScale] = useState('');

    const globalStateMapDistanceKm = globalState.globalStateMapDistanceKm;
    const setGlobalStateMapDistanceKm = globalState.setGlobalStateMapDistanceKm;

    const longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
    const polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
    const selectedYearEditing = globalState.selectedYearEditing;
    const setGlobalPolygonTransparency = globalState.setGlobalPolygonTransparency;
    const setAPIReportMessage = globalState.setAPIReportMessage;

    const [pointGeometryScale, setPointGeometryScale] = useState(null);

    useEffect(() => {
        if (!mapRef.current) return;

        const map = mapRef.current;
        const updateScale = () => setScale(getMapScaleKm(map));
        map.on("zoom", updateScale);
        updateScale();
        return () => map.off("zoom", updateScale);
    }, []);

    useEffect(() => {
        // if (!mapRef.current) return;
        // scaleExistingPointGeometries();
        // setAPIReportMessage('')
        let pointGeometryScale = globalStateMapDistanceKm / 2000;
        scaleExistingPointGeometries(pointGeometryScale)
    }, [mapRef, globalStateMapDistanceKm, polygonCustomLayerRef, longstandingGeoJSONRef, selectedYearEditing]);

    const scaleExistingPointGeometries = (pointGeometryScale) => {
        if (!fmeshPoints) return;
        for (const child of fmeshPoints.children) {
            if (!child.userData.centered) {
                child.geometry.computeBoundingBox();
                const center = new THREE.Vector3();
                child.geometry.boundingBox.getCenter(center);
                child.geometry.translate(-center.x, -center.y, 0);
                child.position.x += center.x;
                child.position.y += center.y;
                child.userData.centered = true;
            }
            child.scale.x = pointGeometryScale;
            child.scale.y = pointGeometryScale
        }
    };

    const changeZoom = (amount) => {
        if (mapRef.current) mapRef.current.zoomTo(mapRef.current.getZoom() + amount, { duration: 150 });
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{ width: '100%', textAlign: 'left', fontSize: '11px', color: '#687975', marginBottom: 4 }}>
                <b>Zoom</b>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <button type="button" aria-label="Zoom out" onClick={() => changeZoom(-1)} style={zoomButtonStyle}>−</button>
                <span aria-live="polite" style={{ fontSize: 12, color: '#52645f' }}>{scale}</span>
                <button type="button" aria-label="Zoom in" onClick={() => changeZoom(1)} style={zoomButtonStyle}>+</button>
            </div>
        </div>
    );
};

const zoomButtonStyle = {
    width: 34,
    height: 30,
    border: '1px solid #cbd7d3',
    borderRadius: 5,
    background: '#fff',
    color: '#245c50',
    fontSize: 18,
    lineHeight: 1,
    cursor: 'pointer',
};

export default ScaleIndicator;
